module.exports = __webpack_public_path__ + "media/images/mobile/abouts/m_bg02-de361e0fd316f27ae4b29dc868263630.jpg";